import React from 'react'
import ContentLoader from 'react-content-loader'

import { Box, tokensRaw } from '@vp/swan'

export const PricingSliderLoader: React.FC = () => {
  return (
    <Box padding={3}>
      <ContentLoader viewBox="0 0 380 70" speed={2} backgroundColor={tokensRaw.SwanBaseColorGrey200} foregroundColor={tokensRaw.SwanBaseColorGrey500}>
        <rect x="6" y="9" rx="0" ry="0" width="179" height="10" />
        <rect x="6" y="30" rx="0" ry="0" width="357" height="10" />
        <rect x="7" y="48" rx="0" ry="0" width="71" height="12" />
        <rect x="290" y="52" rx="0" ry="0" width="71" height="12" />
      </ContentLoader>
    </Box>
  )
}
